/* eslint-disable import/prefer-default-export */
export const RETRIEVE_ME = 'RETRIEVE_ME';
